import React from 'react';
import { IAttributeFilter, IAttributeOption, IAttributeFilterInput } from '@models/VendorVariant/i-vendor-product-group';

import classNames from 'classnames';
import styles from './AttributesFilter.module.scss';

interface IAttributeFilterProps {
  busy?: boolean;
  attributeFilters: IAttributeFilter[];
  selectedAttributeFilters: IAttributeFilterInput[];
  onAttributeFilterChange: (id: string, value: string) => void;
  isAttributeOptionSelected: (option: IAttributeOption) => boolean;
}

interface IAttributeFilterOptionProps {
  option: IAttributeOption;
  onClick: () => void;
  isSelected: boolean;
  isRestricted: boolean;
  busy?: boolean;
}

const AttributeFilterOption = ({
  option,
  onClick,
  isSelected,
  isRestricted,
  busy
}: IAttributeFilterOptionProps) => {
  return (
    <button
      className={classNames(
        styles.AttributeOption,
        { [styles.Selected]: isSelected },
        { [styles.NoResults]: isRestricted }
      )}
      onClick={() => onClick()}
      type="button"
      disabled={busy}
    >
      {option.value}
    </button>
  );
};

const AttributesFilter = ({
  busy,
  attributeFilters,
  onAttributeFilterChange,
  isAttributeOptionSelected
}: IAttributeFilterProps) => {
  return (
    <div className={styles.AttributesFilter}>
      {attributeFilters.map((attr) => (
        <div
          key={`attr-group-${attr.attributeTypeId}`}
          className={styles.AttributeGroup}
        >
          <div className={styles.Title}>
            {attr.title}
          </div>
          <div className={styles.Options}>
            {attr.options.map((option) => (
              <AttributeFilterOption
                key={`${option.attributeTypeId}-${option.value}}`}
                option={option}
                isSelected={isAttributeOptionSelected(option)}
                isRestricted={option.noResults}
                onClick={() => onAttributeFilterChange(option.attributeTypeId, option.value)}
                busy={busy}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AttributesFilter;
